import React from "react";

// Continue Button Component
const ContinueButton = ({
  onClick,
  disabled,
  children,
  isSecondary = false,
}) => (
  <div
    className="fixed bottom-0 w-full flex justify-center z-50 pb-6 pt-8"
    style={{
      background:
        "linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6), transparent)",
    }}
  >
    <div className="w-full max-w-md px-5">
      <button
        onClick={onClick}
        disabled={disabled}
        className={`w-full relative overflow-hidden group font-medium py-4 rounded-xl
        shadow-lg transition-all duration-300 ease-out transform hover:translate-y-[-2px] hover:shadow-xl
        active:translate-y-[1px] active:shadow-md active:scale-[0.98] ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        } ${
          isSecondary
            ? "bg-transparent border border-white/20 text-white"
            : "text-black"
        }`}
        style={
          !isSecondary
            ? { background: "linear-gradient(to right, #b3cc02, #dcff02)" }
            : {}
        }
      >
        <span className="relative z-10 uppercase tracking-wider text-sm font-bold">
          {children}
        </span>

        {!isSecondary && (
          <>
            <div className="absolute top-[-10px] left-[-10px] w-[30px] h-[30px] rounded-full blur-md opacity-70 bg-[#dcff02]" />
            <div className="absolute bottom-[-10px] right-[-10px] w-[30px] h-[30px] rounded-full blur-md opacity-70 bg-[#dcff02]" />
            <div className="absolute top-0 -left-[100%] w-[120%] h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-20deg] group-hover:animate-pulse" />
          </>
        )}
      </button>
    </div>
  </div>
);

export default ContinueButton;
